import types from "./types";

const initialState = {
  incident: null,
  relationships: [],
  perimeter: null,
  perimeterFields: null,
  adsStatus: null,
  preIncidentExtent: null,
  newIncidentProtectingUnit: ""
}

const incidentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INCIDENT:
      return {
        ...state,
        incident: action.payload.incident
      }
    case types.SET_NEWINCIDENT_PROTECTING_UNIT:
      return {
        ...state,
        newIncidentProtectingUnit: action.payload.protectingUnit
      }
    case types.CLEAR_INCIDENT:
      return {
        ...state,
        incident: null
      }
      case types.SET_RELATIONSHIPS:
        return {
          ...state,
          relationships: action.payload.relationships
        }
      case types.CLEAR_RELATIONSHIPS:
        return {
          ...state,
          relationships: null
        }
        case types.SET_ADS_STATUS:
          return {
            ...state,
            adsStatus: action.payload.adsStatus
          }
        case types.CLEAR_ADS_STATUS:
          return {
            ...state,
            ADSStatus: null
          }
      case types.SET_PERIMETER:
        return {
          ...state,
          perimeter: action.payload.perimeter
        }
      case types.SET_PERIMETER_FIELDS:
        return {
          ...state,
          perimeterFields: action.payload.perimeterFields
        }
      case types.SET_PRE_INCIDENT_EXTENT:
        return {
          ...state,
          preIncidentExtent: action.payload.preIncidentExtent
        }
      case types.CLEAR_PERIMETER:
        return {
          ...state,
          perimeter: null
        }
      case types.CLEAR_PERIMETER_FIELDS:
        return {
          ...state,
          perimeterFields: null
        }
    default:
      return state;
  }
}

export default incidentReducer;
